// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TvfN","colMin":"styles_colMin__3iqmw"};